import type {ReactElement} from 'react';
import type {QRAppStoreInput} from '@Libraries/qr-code/qr-code.types';
import {QRPayloadField} from '@Libraries/qr-code/qr-code.types';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export function QRAppStoreForm({input, issues, onPatch}: QRFormProps<QRAppStoreInput>): ReactElement {
  return (
    <>
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_app_store_link_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_app_store_link_placeholder')}
        value={input.appStoreLink}
        field={QRPayloadField.APP_STORE_LINK}
        issues={issues}
        onValueChange={(appStoreLink): void => {
          onPatch({appStoreLink});
        }}
      />
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_play_store_link_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_play_store_link_placeholder')}
        helpText={window.i18next.t('pmwjs_qr_generator_app_store_help')}
        value={input.playStoreLink}
        field={QRPayloadField.PLAY_STORE_LINK}
        issues={issues}
        onValueChange={(playStoreLink): void => {
          onPatch({playStoreLink});
        }}
      />
    </>
  );
}
